import { createContext, useCallback, useContext } from 'react';

import { useSyncRef } from 'hooks/syncRef';

import { type ConfirmationModalProps } from './Modal';

export type RequestConfirmationParams = Omit<ConfirmationModalProps, 'cancel' | 'isOpen'> &
  Partial<Pick<ConfirmationModalProps, 'cancel'>>;

interface ConfirmationCtxData {
  requestConfirmation(message: RequestConfirmationParams): void;
}

export const ConfirmationCtx = createContext<ConfirmationCtxData>({} as ConfirmationCtxData);

export function useConfirmation(): ConfirmationCtxData {
  const context = useContext(ConfirmationCtx);

  if (!context.requestConfirmation) {
    throw new Error('useToast must be used within a ConfirmationProvider');
  }

  return context;
}

export function useSingleConfirmation(params: RequestConfirmationParams): () => void {
  const { requestConfirmation } = useConfirmation();

  // optimized correctly
  const paramsRef = useSyncRef(params);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(() => requestConfirmation(paramsRef.current), [requestConfirmation]);
}
